import { render, staticRenderFns } from "./SamclickNumber.vue?vue&type=template&id=5b023040&scoped=true&"
import script from "./SamclickNumber.vue?vue&type=script&lang=ts&"
export * from "./SamclickNumber.vue?vue&type=script&lang=ts&"
import style0 from "./SamclickNumber.vue?vue&type=style&index=0&id=5b023040&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b023040",
  null
  
)

export default component.exports